"use strict";

exports.__esModule = true;
exports.DeviceDataItemGrid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FlexGrid = require("../../Core/FlexGrid/FlexGrid");
var _DeviceDataItemSubscription = require("../DeviceDataItemSubscription");
var _MeasurementValue = require("../../Measures/MeasurementValue");
var _FlexPassthrough = require("../../Core/FlexGrid/FlexPassthrough");
var _excluded = ["device", "dataItems"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var getSVGRowProps = function getSVGRowProps() {
  return {
    component: "svg"
  };
};

/**
 * Renders a virtualized grid of live data item values for a specific device.
 */
var DeviceDataItemGrid = exports.DeviceDataItemGrid = /*#__PURE__*/function (_Component) {
  function DeviceDataItemGrid() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderItem = function (_ref) {
      var index = _ref.index;
      var _this$props = _this.props,
        device = _this$props.device,
        dataItems = _this$props.dataItems;
      var dataItem = dataItems[index];
      return /*#__PURE__*/_react["default"].createElement(_FlexPassthrough.FlexPassthrough, null, function (position) {
        return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSubscription.DeviceDataItemSubscription, {
          key: index,
          deviceUuid: device.uuid,
          dataItem: dataItem
        }, function (packet) {
          return /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, _extends({}, position, {
            value: packet && packet.value,
            units: dataItem.units || "",
            label: dataItem.name || ""
          }));
        });
      });
    };
    return _this;
  }
  _inheritsLoose(DeviceDataItemGrid, _Component);
  var _proto = DeviceDataItemGrid.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props2 = this.props,
      device = _this$props2.device,
      dataItems = _this$props2.dataItems,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_FlexGrid.FlexGrid, _extends({
      itemCount: dataItems.length,
      renderItem: this.renderItem,
      getRowProps: getSVGRowProps
    }, extra));
  };
  return DeviceDataItemGrid;
}(_react.Component);